'use client';

export default function AutoBidButton({ children, value, token, onSubmit }) {
  return (
    <div className="tooltip" data-tip={`Bid ${value} ${token}`}>
      <button className="btn btn-primary" onClick={() => onSubmit(value)}>
        {children || `Bid ${value} ${token}`}
      </button>
    </div>
  );
}
